module.exports = __webpack_public_path__ + "img/ar.a51613f0.svg";